import { AccessPointsUtil } from '@/components/goals/common/access_points'
import { AdaptedGoalValues } from './adapted_goal_levels'
import { isSubjectELL } from './goals'

export { gradeInstructionalLevels, levelsOfSupportForSubject, goalWizardLevels, goalWizardLevelToLevelOfSupport }

const gradeInstructionalLevels = Object.freeze({
  AT_GRADE_LEVEL: 'At grade level',
  ABOVE_GRADE_LEVEL: 'Above grade level',
  BELOW_GRADE_LEVEL: 'Below grade level',
  TWO_ABOVE_GRADE_LEVEL: '1 or 2 grades above grade level',
  TWO_BELOW_GRADE_LEVEL: '1 or 2 grade levels below',
  THREE_BELOW_GRADE_LEVEL: '3+ grade levels below'
})

const goalWizardLevels = Object.freeze({
  LESS: 'less',
  SOME: 'some',
  MORE: 'more',
})

function levelsOfSupportForSubject(subject) {
  if (isSubjectELL(subject)) {
    return ellLevelsOfSupportMapping
  }
  return defaultLevelsOfSupportMapping
}

const defaultLevelsOfSupportMapping = [
  {
    accessPointLevel: AccessPointsUtil.valuesMap.GRADE_LEVEL,
    adaptedGoalLevels: AdaptedGoalValues.GRADE
  },
  {
    accessPointLevel: AccessPointsUtil.valuesMap.APPROACHING,
    adaptedGoalLevels: AdaptedGoalValues.MODERATE
  },
  {
    accessPointLevel: AccessPointsUtil.valuesMap.DEVELOPING,
    adaptedGoalLevels: AdaptedGoalValues.INTENSE
  }
]

const ellLevelsOfSupportMapping = [
  {
    accessPointLevel: AccessPointsUtil.valuesMap.GRADE_LEVEL,
    adaptedGoalLevels: ''
  },
  {
    accessPointLevel: AccessPointsUtil.valuesMap.APPROACHING,
    adaptedGoalLevels: AdaptedGoalValues.INTERMEDIATE
  },
  {
    accessPointLevel: AccessPointsUtil.valuesMap.APPROACHING,
    adaptedGoalLevels: AdaptedGoalValues.BEGINNER
  }
]

const goalWizardLevelToLevelOfSupport = Object.freeze({
  [goalWizardLevels.LESS]: 0,
  [goalWizardLevels.SOME]: 1,
  [goalWizardLevels.MORE]: 2,
})